import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';
import {Utils} from "../../../../shared/utils/utils";
import {Product} from "../../product";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {ProductService} from "../../product.service";
import {UserSubscription, UserSubscriptionType} from "../../../../user/user-subscription";
import {filter, first} from "rxjs/operators";

export interface IUnavailableDialogData {
  header: string;
  fromLocal: string;
  plugins: Product[];
  userSubscription: UserSubscription['type'];
}
@Component({
    selector: 'db-unavailable-dialog',
    templateUrl: './unavailable-dialog.component.html',
    styleUrls: ['./unavailable-dialog.component.scss'],
    standalone: false
})
export class UnavailableDialogComponent extends DialogComponent<IUnavailableDialogData, Boolean> implements IUnavailableDialogData, OnInit {

  @Input() header: string;
  @Input() fromLocal: string;
  @Input() plugins: Product[];
  @Input() userSubscription: UserSubscription['type'];

  public downloadingProducts: {[key: number]:  number} = {};
  public filteredPlugins: Product[] = [];

  constructor(
    private _dialogService: DialogService,
    private _productService: ProductService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this._filterPlugins();
    localStorage.getItem('fromLocal') && localStorage.removeItem('fromLocal');
  }

  private _filterPlugins(): void {
    /** if it's fromLocal, or it has mentioned subscription get only paid plugins */
    if ( this.userSubscription === 'one_product' || this.fromLocal) {
      this.filteredPlugins = this.plugins.filter(product => product.paidVersionAvailable);
    }

    /** if there's no paid plugins display all */
    if (this.filteredPlugins && !this.filteredPlugins.length
      && [
        UserSubscriptionType.ONE_PRODUCT,
        UserSubscriptionType.PLATFORM,
        UserSubscriptionType.PREMIUM,
      ].includes(this.userSubscription)) {
      this.filteredPlugins = this.plugins;
    }
  }


  public downloadPlugin(pluginId: number, pluginName: string): void {
    this.downloadingProducts[pluginId] = 0;
    this._downloadingSimulation(pluginId).then(() => this._productService.startDownloadingPlugin(pluginId)
      .pipe(
        filter(response => !!response),
        first()
      )
      .subscribe((response: DbResponse) => {
        this.downloadingProducts[pluginId] = 100;
        if (response && response.success) {
          Utils.downloadBlob(response.data, pluginName);
        }
        else {
          NotifierComponent.notify(
            new Notification(response.message || "something went wrong", NotificationType.DANGER)
          );
        }
        this._removeFromDownloadList(pluginId);
      })
    );
  }

  private _downloadingSimulation(pluginId: number): Promise<void> {
    return new Promise((resolve) => {
      this.downloadingProducts[pluginId] = 0;
      const progress = setInterval(() => {
        if (this.downloadingProducts[pluginId] !== 90) {
          this.downloadingProducts[pluginId] += 10;
        }
        else {
          resolve();
          clearInterval(progress);
        }
      }, 200);
    });
  }

  private _removeFromDownloadList(pluginId: number): void {
    const index = this.downloadingProducts[pluginId];
    index > -1 && setTimeout(() => {
      delete this.downloadingProducts[pluginId];
    }, 500);
  }
}
